import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { catchError, map } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserfirestoreService {
  // All products

  constructor(private angularFireStore: AngularFirestore) {}

  users$ = this.angularFireStore
    .collection(`users`)
    .valueChanges()
    .pipe(catchError(this.handleError));

  getUsers() {
    return this.angularFireStore
      .collection(`users`)
      .valueChanges()
      .pipe(catchError(this.handleError));
  }

  getUserById(uId) {
    return this.angularFireStore.doc(`/users/${uId}`);
  }

  createUser(user) {
    //return this.angularFireStore.collection(`users`).add(user);
    return this.angularFireStore
      .collection(`users`)
      .doc(`${user.uid}`)
      .set(user);
  }

  editUser(user) {
    // return this.angularFireStore.collection('users').doc()
    return this.angularFireStore.doc(`users/${user.id}`).update(user);
  }

  editUserField(id, fields) {
    return this.angularFireStore
      .collection(`users`)
      .doc(`${id}`)
      .update(fields);
  }

  deleteUser(user) {
    return this.angularFireStore.doc(`users/${user.id}`).delete();
  }

  setAvatar(avatar, uid) {
    return this.angularFireStore.collection(`users`).doc(`${uid}`).update({
      avatar: avatar,
    });
  }

  private handleError(err: any) {
    // in a real world app, we may send the server to some remote logging infrastructure
    // instead of just logging it to the console
    let errorMessage: string;
    if (err.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      errorMessage = `An error occurred: ${err.error.message}`;
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      errorMessage = `Backend returned code ${err.status}: ${err.body.error}`;
    }
    console.error(err);
    return throwError(errorMessage);
  }
}
